export default [
        {
          imageUrl: 'https://www.airasia.com/aa/bigpay/images/illustration_1.png',
          subTitle: 'Gunakan kad BigPay untuk belian penerbangan tiket AirAsia anda dan dapatkan penjimatan dengan diskaun hebat !',
          title: 'Pasangan tawaran penerbangan terbaik'
        },
        {
          imageUrl: 'https://www.airasia.com/aa/bigpay/images/illustration_2.png',
          subTitle: 'Dapatkan kadar tukaran matawang asing terbaik kad BigPay di lebih daripada 64 juta peniaga seluruh dunia.',
          title: 'Kadar tukaran matawang asing terbaik'
        },
        {
            imageUrl: 'https://www.airasia.com/aa/bigpay/images/illustration_4.png',
            subTitle: 'Dapatkan mata ganjaran, nikmati diskaun atas penerbangan AirAsia dan produk lain airasia serta pulangan tunai bila anda menggunakan BigPay.',
            title: 'Tawaran khas untuk ahli!'
          },
          {
            imageUrl: 'https://www.airasia.com/aa/bigpay/images/illustration_5.png',
            subTitle: 'Kad maya BigPay membolehkan anda membuat transaksi atas talian serta-merta dengan pengaktifan akaun anda.',
            title: 'Kad maya BigPay'
          },
          {
              imageUrl: 'https://www.airasia.com/aa/bigpay/images/illustration_6.png',
              subTitle: 'Buat bayaran dalam matawang tempatan dengan kadar forex terbaik dengan Bayaran QR Rentas Sempadan BigPay. Mudah dan murah!  ',
              title: 'Bayaran QR Rentas Sempadan BigPay'
            },
            {
              imageUrl: 'https://www.airasia.com/aa/bigpay/images/get-2x-airasia-points.png',
              subTitle: 'Nikmati 2x airasia points dengan setiap belian. Belanja lebih dan peroleh lebih banyak airasia points!',
              title: '2x airasia points untuk anda!'
            }
]